import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, ViewChild, APP_INITIALIZER, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * @abstract
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["ngxCookiebot"];
class NgxCookiebotConfig {
}
if (false) {
    /** @type {?} */
    NgxCookiebotConfig.prototype.blockingMode;
    /** @type {?} */
    NgxCookiebotConfig.prototype.cbId;
    /** @type {?} */
    NgxCookiebotConfig.prototype.culture;
    /** @type {?} */
    NgxCookiebotConfig.prototype.framework;
    /** @type {?} */
    NgxCookiebotConfig.prototype.level;
    /** @type {?} */
    NgxCookiebotConfig.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getWindow() {
    return window;
}
/**
 * Exposes the 'Cookiebot' object provided by the Cookiebot SDK
 * https://www.cookiebot.com/en/developer/
 */
class NgxCookiebotService {
    /**
     *
     * @param {?} cookiebotConfig
     */
    constructor(cookiebotConfig) {
        this.cookiebotConfig = cookiebotConfig;
        this._onAcceptCallback$ = new Subject();
        this.onAcceptCallback$ = this._onAcceptCallback$.asObservable();
        this._onDeclineCallback$ = new Subject();
        this.onDeclineCallback$ = this._onDeclineCallback$.asObservable();
        this._onDialogDisplayCallback$ = new Subject();
        this.onDialogDisplayCallback$ = this._onDialogDisplayCallback$.asObservable();
        this._onDialogInitCallback$ = new Subject();
        this.onDialogInitCallback$ = this._onDialogInitCallback$.asObservable();
        this._onLoadCallback$ = new Subject();
        this.onLoadCallback$ = this._onLoadCallback$.asObservable();
        this._onServiceReady$ = new BehaviorSubject(false);
        this.onServiceReady$ = this._onServiceReady$.asObservable();
        this._onTagsExecutedCallback$ = new Subject();
        this.onTagsExecutedCallback$ = this._onTagsExecutedCallback$.asObservable();
        this._window = new Subject();
        this._verifyConfig();
        this._window = getWindow();
    }
    /**
     *
     * @return {?}
     */
    init() {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            try {
                this._window.document.head.append(this._buildScriptTag());
            }
            catch (e) {
                this._onServiceReady$.error(e);
                return resolve();
            }
            /** @type {?} */
            const scriptInjectionTimeout = setTimeout((/**
             * @return {?}
             */
            () => {
                this._onServiceReady$.error('Timed out');
                clearInterval(scriptInjectionCheckInterval);
            }), 30000);
            // 30 seconds
            /** @type {?} */
            const scriptInjectionCheckInterval = setInterval((/**
             * @return {?}
             */
            () => {
                // The Cookiebot people added and ID to the script tag
                // with the same name as the object it exposes
                // https://twitter.com/jacksdrobinson/status/1188152645032255491
                if (!(this._window.Cookiebot instanceof HTMLElement)) {
                    this.cookiebot = this._window.Cookiebot;
                    this._setUpCallbacks();
                    this._setUpEventHandlers();
                    clearInterval(scriptInjectionCheckInterval);
                    clearTimeout(scriptInjectionTimeout);
                    this._onServiceReady$.next(true);
                }
            }), 10);
            return resolve();
        }));
    }
    /**
     *
     * @private
     * @return {?}
     */
    _buildScriptTag() {
        /** @type {?} */
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'Cookiebot';
        script.src = 'https://consent.cookiebot.com/uc.js';
        script.setAttribute('data-cbid', this.cookiebotConfig.cbId);
        if ('auto' === this.cookiebotConfig.blockingMode) {
            script.setAttribute('data-blockingmode', 'auto');
        }
        else {
            script.async = true;
        }
        if (this.cookiebotConfig.culture) {
            script.setAttribute('data-culture', this.cookiebotConfig.culture);
        }
        if (this.cookiebotConfig.framework) {
            script.setAttribute('data-framework', this.cookiebotConfig.framework);
        }
        if (this.cookiebotConfig.level) {
            script.setAttribute('data-level', this.cookiebotConfig.level);
        }
        if (this.cookiebotConfig.type) {
            script.setAttribute('data-type', this.cookiebotConfig.type);
        }
        return script;
    }
    /**
     *
     * @private
     * @return {?}
     */
    _setUpCallbacks() {
        // @ts-ignore
        window.CookiebotCallback_OnAccept = (/**
         * @return {?}
         */
        () => {
            this._onAcceptCallback$.next();
        });
        // @ts-ignore
        window.CookiebotCallback_OnDecline = (/**
         * @return {?}
         */
        () => {
            this._onDeclineCallback$.next();
        });
        // @ts-ignore
        window.CookiebotCallback_OnDialogDisplay = (/**
         * @return {?}
         */
        () => {
            this._onDialogDisplayCallback$.next();
        });
        // @ts-ignore
        window.CookiebotCallback_OnDialogInit = (/**
         * @return {?}
         */
        () => {
            this._onDialogInitCallback$.next();
        });
        // @ts-ignore
        window.CookiebotCallback_OnLoad = (/**
         * @return {?}
         */
        () => {
            this._onLoadCallback$.next();
        });
        // @ts-ignore
        window.CookiebotCallback_OnTagsExecuted = (/**
         * @return {?}
         */
        () => {
            this._onTagsExecutedCallback$.next();
        });
    }
    /**
     *
     * @private
     * @return {?}
     */
    _setUpEventHandlers() {
        this.onAccept$ = fromEvent(this._window, 'CookiebotOnAccept');
        this.onConsentReady$ = fromEvent(this._window, 'CookiebotOnConsentReady');
        this.onDecline$ = fromEvent(this._window, 'CookiebotOnDecline');
        this.onDialogInit$ = fromEvent(this._window, 'CookiebotOnDialogInit');
        this.onDialogDisplay$ = fromEvent(this._window, 'CookiebotOnDialogDisplay');
        this.onLoad$ = fromEvent(this._window, 'CookiebotOnLoad');
        this.onTagsExecuted$ = fromEvent(this._window, 'CookiebotOnTagsExecuted');
    }
    /**
     *
     * @private
     * @return {?}
     */
    _verifyConfig() {
        if (!this.cookiebotConfig.cbId) {
            throw new Error('Missing cbId. Please provide a Cookiebot config with a cbId');
        }
        if (!this.cookiebotConfig.blockingMode) {
            throw new Error('Missing blockingMode. Please provide a Cookiebot config with blockingMode');
        }
    }
}
NgxCookiebotService.ɵfac = function NgxCookiebotService_Factory(t) { return new (t || NgxCookiebotService)(ɵngcc0.ɵɵinject(NgxCookiebotConfig)); };
NgxCookiebotService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxCookiebotService, factory: NgxCookiebotService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgxCookiebotService.ctorParameters = () => [
    { type: NgxCookiebotConfig }
];
/** @nocollapse */ NgxCookiebotService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgxCookiebotService_Factory() { return new NgxCookiebotService(ɵɵinject(NgxCookiebotConfig)); }, token: NgxCookiebotService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCookiebotService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgxCookiebotConfig }]; }, null); })();
if (false) {
    /** @type {?} */
    NgxCookiebotService.prototype.cookiebot;
    /** @type {?} */
    NgxCookiebotService.prototype.onAccept$;
    /** @type {?} */
    NgxCookiebotService.prototype.onLoad$;
    /** @type {?} */
    NgxCookiebotService.prototype.onConsentReady$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDecline$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDialogInit$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDialogDisplay$;
    /** @type {?} */
    NgxCookiebotService.prototype.onTagsExecuted$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onAcceptCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onAcceptCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onDeclineCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDeclineCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onDialogDisplayCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDialogDisplayCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onDialogInitCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onDialogInitCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onLoadCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onLoadCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onServiceReady$;
    /** @type {?} */
    NgxCookiebotService.prototype.onServiceReady$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._onTagsExecutedCallback$;
    /** @type {?} */
    NgxCookiebotService.prototype.onTagsExecutedCallback$;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype._window;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotService.prototype.cookiebotConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 */
class NgxCookiebotComponent {
    /**
     *
     * @param {?} _ngxCookiebotConfig
     */
    constructor(_ngxCookiebotConfig) {
        this._ngxCookiebotConfig = _ngxCookiebotConfig;
    }
    /**
     *
     *
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookiebot.com/' + this._ngxCookiebotConfig.cbId + '/cd.js';
        script.async = true;
        this.ngxCookiebotElement.nativeElement.append(script);
    }
}
NgxCookiebotComponent.ɵfac = function NgxCookiebotComponent_Factory(t) { return new (t || NgxCookiebotComponent)(ɵngcc0.ɵɵdirectiveInject(NgxCookiebotConfig)); };
NgxCookiebotComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxCookiebotComponent, selectors: [["ngx-cookiebot-declaration"]], viewQuery: function NgxCookiebotComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngxCookiebotElement = _t.first);
    } }, decls: 2, vars: 0, consts: [["ngxCookiebot", ""]], template: function NgxCookiebotComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", null, 0);
    } }, styles: ["[_nghost-%COMP%] {display: block}"] });
/** @nocollapse */
NgxCookiebotComponent.ctorParameters = () => [
    { type: NgxCookiebotConfig }
];
NgxCookiebotComponent.propDecorators = {
    ngxCookiebotElement: [{ type: ViewChild, args: ['ngxCookiebot', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCookiebotComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ngx-cookiebot-declaration',
                template: '<div #ngxCookiebot></div>',
                styles: [':host {display: block}']
            }]
    }], function () { return [{ type: NgxCookiebotConfig }]; }, { ngxCookiebotElement: [{
            type: ViewChild,
            args: ['ngxCookiebot', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    NgxCookiebotComponent.prototype.ngxCookiebotElement;
    /**
     * @type {?}
     * @private
     */
    NgxCookiebotComponent.prototype._ngxCookiebotConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * @param {?} cookieBotService
 * @return {?}
 */
function ngxCookiebotFactory(cookieBotService) {
    return (/**
     * @return {?}
     */
    () => {
        return cookieBotService.init();
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 */
class NgxCookiebotModule {
    /**
     * @param {?} cookiebotConfig
     * @return {?}
     */
    static forRoot(cookiebotConfig) {
        return {
            ngModule: NgxCookiebotModule,
            providers: [
                { provide: NgxCookiebotConfig, useClass: cookiebotConfig },
                { provide: NgxCookiebotService, useClass: NgxCookiebotService, deps: [NgxCookiebotConfig] },
                { provide: APP_INITIALIZER, useFactory: ngxCookiebotFactory, deps: [NgxCookiebotService], multi: true }
            ]
        };
    }
}
NgxCookiebotModule.ɵfac = function NgxCookiebotModule_Factory(t) { return new (t || NgxCookiebotModule)(); };
NgxCookiebotModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCookiebotModule });
NgxCookiebotModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCookiebotModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxCookiebotComponent
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    NgxCookiebotComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCookiebotModule, { declarations: function () { return [NgxCookiebotComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxCookiebotComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxCookiebotComponent, NgxCookiebotConfig, NgxCookiebotModule, NgxCookiebotService, ngxCookiebotFactory as ɵa };

